/**
 * Wandcalculator.
 *
 * Rekent het benodigde aantal elementen uit en voegt die daadwerkelijk toe
 * aan de Shopify-winkelmand via /cart/add.js.
 *
 * Alle prijzen komen uit het JSON-blok dat de sectie rendert; er staat geen
 * bedrag in dit bestand. Bedragen worden geformatteerd met de actieve valuta
 * van de markt, zodat dit ook klopt in België, Duitsland of Frankrijk.
 */
(function () {
  'use strict';

  // Voorkomt dubbele initialisatie wanneer dit bestand twee keer wordt ingeladen.
  if (window.__themeCalculator) return;
  window.__themeCalculator = true;

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'nl';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function formatNumber(value, decimals) {
    var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'nl';

    try {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    } catch (error) {
      return value.toFixed(decimals);
    }
  }

  function Calculator(root) {
    this.root = root;
    this.data = this.readData();

    if (!this.data || !this.data.series.length) return;

    this.widthInput = root.querySelector('[data-calc-width]');
    this.heightInput = root.querySelector('[data-calc-height]');
    this.seriesSelect = root.querySelector('[data-calc-series]');
    this.modeSelect = root.querySelector('[data-calc-mode]');
    this.sqmOutput = root.querySelector('[data-calc-sqm]');
    this.panelsOutput = root.querySelector('[data-calc-panels]');
    this.gridOutput = root.querySelector('[data-calc-grid]');
    this.totalOutput = root.querySelector('[data-calc-total]');
    this.distributionOutput = root.querySelector('[data-calc-distribution]');
    this.addButton = root.querySelector('[data-calc-add]');
    this.message = root.querySelector('[data-calc-message]');

    this.areaPerElement = parseFloat(this.data.areaPerElement) || 0.25;
    this.lines = [];

    this.bindEvents();
    this.populateModes();
    this.calculate();
  }

  Calculator.prototype.readData = function () {
    var script = this.root.querySelector('[data-calculator-data]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  };

  Calculator.prototype.currentSeries = function () {
    var id = this.seriesSelect ? this.seriesSelect.value : null;
    var match = this.data.series.filter(function (series) {
      return series.id === id;
    })[0];
    return match || this.data.series[0];
  };

  Calculator.prototype.bindEvents = function () {
    var self = this;

    [this.widthInput, this.heightInput].forEach(function (input) {
      if (input) input.addEventListener('input', self.calculate.bind(self));
    });

    if (this.seriesSelect) {
      this.seriesSelect.addEventListener('change', function () {
        self.populateModes();
        self.calculate();
      });
    }

    if (this.modeSelect) {
      this.modeSelect.addEventListener('change', this.calculate.bind(this));
    }

    if (this.addButton) {
      this.addButton.addEventListener('click', this.addToCart.bind(this));
    }
  };

  /**
   * Vult de uitvoeringsdropdown met de producten van de gekozen serie.
   * Nieuwe producten in de collectie verschijnen hier automatisch.
   */
  Calculator.prototype.populateModes = function () {
    if (!this.modeSelect) return;

    var series = this.currentSeries();
    var mixLabel = this.modeSelect.options.length ? this.modeSelect.options[0].textContent : 'Gemengd';

    this.modeSelect.innerHTML = '';

    if (series.products.length > 1) {
      var mixOption = document.createElement('option');
      mixOption.value = 'mix';
      mixOption.textContent = mixLabel;
      this.modeSelect.appendChild(mixOption);
    }

    series.products.forEach(function (product, index) {
      var option = document.createElement('option');
      option.value = String(index);
      option.textContent = product.title;
      if (!product.available) {
        option.disabled = true;
      }
      this.modeSelect.appendChild(option);
    }, this);

    this.modeSelect.disabled = series.products.length < 2;
  };

  Calculator.prototype.calculate = function () {
    var series = this.currentSeries();
    var width = Math.max(0, parseFloat(this.widthInput && this.widthInput.value) || 0);
    var height = Math.max(0, parseFloat(this.heightInput && this.heightInput.value) || 0);
    var sqm = width * height;

    // Hele elementen per rij en per kolom. Alles wat over een hele plaat heen
    // gaat (ook 1 cm) wordt een extra plaat. Er wordt in millimeters gerekend,
    // zodat afrondingsfouten van de computer geen extra plaat opleveren.
    var sideMm = Math.round(Math.sqrt(this.areaPerElement) * 1000); // 0.25 m2 -> 500 mm
    var widthMm = Math.round(width * 1000);
    var heightMm = Math.round(height * 1000);
    var columns = sideMm > 0 && widthMm > 0 ? Math.ceil(widthMm / sideMm) : 0;
    var rows = sideMm > 0 && heightMm > 0 ? Math.ceil(heightMm / sideMm) : 0;
    var panels = columns * rows;
    var mode = this.modeSelect ? this.modeSelect.value : 'mix';

    this.lines = [];

    if (panels > 0 && series.products.length) {
      if (mode === 'mix') {
        // Verdeel zo gelijk mogelijk over alle producten in de serie.
        var count = series.products.length;
        var base = Math.floor(panels / count);
        var remainder = panels % count;

        series.products.forEach(function (product, index) {
          var quantity = base + (index < remainder ? 1 : 0);
          if (quantity > 0) {
            this.lines.push({ product: product, quantity: quantity });
          }
        }, this);
      } else {
        var chosen = series.products[parseInt(mode, 10)];
        if (chosen) {
          this.lines.push({ product: chosen, quantity: panels });
        }
      }
    }

    var total = this.lines.reduce(function (sum, line) {
      return sum + line.product.price * line.quantity;
    }, 0);

    if (this.sqmOutput) this.sqmOutput.textContent = formatNumber(sqm, 2);
    if (this.panelsOutput) this.panelsOutput.textContent = panels;
    if (this.gridOutput) {
      this.gridOutput.textContent = panels > 0
        ? columns + ' × ' + rows + ' (' + formatNumber((columns * sideMm) / 1000, 2) + ' × ' + formatNumber((rows * sideMm) / 1000, 2) + ' m)'
        : '—';
    }
    if (this.totalOutput) this.totalOutput.textContent = total > 0 ? formatMoney(total) : '—';

    if (this.distributionOutput) {
      this.distributionOutput.textContent = this.lines.length
        ? this.lines
            .map(function (line) {
              var name = line.product.shortTitle || line.product.title;
              return line.quantity + '\u00d7 ' + name;
            })
            .join(' · ')
        : '—';
    }

    var unavailable = this.lines.some(function (line) {
      return !line.product.available;
    });

    if (this.addButton) {
      this.addButton.disabled = this.lines.length === 0 || unavailable;
    }

    this.setMessage(unavailable ? window.theme.strings.calculatorUnavailable : '');
  };

  Calculator.prototype.setMessage = function (text) {
    if (this.message) this.message.textContent = text || '';
  };

  Calculator.prototype.addToCart = function () {
    var self = this;

    if (!this.lines.length) {
      this.setMessage(window.theme.strings.calculatorNoProducts);
      return;
    }

    var items = this.lines.map(function (line) {
      return { id: line.product.variantId, quantity: line.quantity };
    });

    var originalLabel = this.addButton.textContent;
    this.addButton.disabled = true;
    this.addButton.textContent = window.theme.strings.calculatorAdding;
    this.setMessage('');

    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message);
          return body;
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));

        if (window.theme.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:open'));
          self.addButton.textContent = originalLabel;
          self.addButton.disabled = false;
        } else {
          window.location.href = window.theme.routes.cart;
        }
      })
      .catch(function (error) {
        self.setMessage(error.message || window.theme.strings.calculatorError);
        self.addButton.textContent = originalLabel;
        self.addButton.disabled = false;
      });
  };

  function init() {
    document.querySelectorAll('[data-calculator]').forEach(function (root) {
      if (root.dataset.calculatorReady) return;
      root.dataset.calculatorReady = 'true';
      new Calculator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Opnieuw initialiseren wanneer de Theme Editor een sectie herlaadt.
  document.addEventListener('shopify:section:load', init);
})();